import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}


// Build an embeddable player URL from a YouTube or Vimeo link (or bare YouTube ID).
export function videoEmbedUrl(input) {
  if (!input) return "";
  const s = input.trim();
  if (/^[A-Za-z0-9_-]{11}$/.test(s)) return `https://www.youtube.com/embed/${s}?rel=0`;
  const yt = s.match(/(?:youtube\.com\/(?:watch\?[^ ]*?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}?rel=0`;
  const vimeo = s.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;
  return "";
}
